export const RouterLoading = {
  namespaced: true,
  state: () => ({
    loading: false,
  }),
  actions: {
    startLoading: ({ commit }) => commit('setLoading', true),
    stopLoading: ({ commit }) => commit('setLoading', false),
  },
  mutations: {
    setLoading: (state, value) => { state.loading = value },
  },
  getters: {
    isLoading: state => state.loading,
  },
}
